(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-overview"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collection-item--prd a').forEach(link => {
  link.addEventListener('click', function() {    
    this.classList.add('active');    
    setTimeout(() => {
      this.classList.remove('active');
    }, 5000);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-partners-section"] && !Shopify.designMode) return;
  try {
    
(function() {
  function hotel_partners_slider() {
    var section = document.querySelector('.section-hotel-partners');
    if (!section) return;

    var thumbEl = section.querySelector('.hotel-partners-thumb');
    var navEl   = section.querySelector('.hotel-partners-nav');
    if (!thumbEl || !navEl) return;

    if (thumbEl._hotelThumbSwiper) {
      try { thumbEl._hotelThumbSwiper.destroy(true, true); } catch(e) {}
      thumbEl._hotelThumbSwiper = null;
    }
    if (navEl._hotelNavSwiper) {
      try { navEl._hotelNavSwiper.destroy(true, true); } catch(e) {}
      navEl._hotelNavSwiper = null;
    }

    var thumbSwiper = new Swiper(thumbEl, {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto',
      threshold: 5,
      breakpoints: {
        300: { direction: 'horizontal' },
        992: { direction: 'vertical' }
      }
    });

    var navSwiper = new Swiper(navEl, {
      loop: false,
      spaceBetween: 0,
    //   slidesPerView: 1,
      navigation: {
        nextEl: ".hotel-partners-media .swiper-button-next",
        prevEl: ".hotel-partners-media .swiper-button-prev",
      },
      pagination: {
        el: ".hotel-partners-media .hotel-partners-thumb-container .swiper-pagination",
        type: "fraction"
      },
      thumbs: {
        swiper: thumbSwiper
      },
      breakpoints: {
        300: { direction: 'horizontal' },
        992: { direction: 'vertical' }
      },
      on: {
        slideChange: function() {
          var index = this.activeIndex;
          var textPanels = section.querySelectorAll('.hotel-partner-slide-text');
          textPanels.forEach(function(panel) {
            panel.classList.remove('is-active');
          });
          var activePanel = section.querySelector('.hotel-partner-slide-text[data-index="' + index + '"]');
          if (activePanel) activePanel.classList.add('is-active');
        }
      }
    });

    thumbEl._hotelThumbSwiper = thumbSwiper;
    navEl._hotelNavSwiper     = navSwiper;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hotel_partners_slider);
  } else {
    hotel_partners_slider();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }    		
              var productslider=[];
              document.querySelectorAll('.product-carousel').forEach(function(Element,index){    
                let productid = Element.dataset.id;
                let outer_carousel = Element.closest('.carousel-rowouter');
                let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
                let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
                let swiperObject={
                  // loop:eval(Element.dataset.loop),
                  slidesPerView: "auto",
                  navigation: {
                    nextEl:nextbutton,
                    prevEl:prevbutton,
                  },
                  breakpoints: {
                    0: {
                      slidesPerView: 2.35
                    },
                    768: {
                      slidesPerView: 'auto'
                    },
                  }
                };    
                productslider[productid]=new Swiper(Element,swiperObject);
              }); 
              document.querySelectorAll('.grid-size-variants').forEach(list => {
                let items = Array.from(list.querySelectorAll('.variant-grid'));
                items.sort((a, b) => {
                  let aPrice = parseFloat(a.getAttribute('data-price')) || 0;
                  let bPrice = parseFloat(b.getAttribute('data-price')) || 0;
                  return aPrice - bPrice;
                });
                items.forEach(item => list.appendChild(item));
              });
              if(typeof quickAddButton == 'function'){
              quickAddButton();
              }
              if(typeof revealEffects == 'function'){
              revealEffects();
              }
              if(typeof initMobileProductToggle == 'function'){
                initMobileProductToggle();
              }
              
              document.querySelectorAll('.mobile-add-icon').forEach(button => {
                button.addEventListener('click', function() {
                  const productGrid = button.closest('.snippet-product-grid');
                  if (!productGrid) return;

                  const popup = productGrid.querySelector('.var-popup-wrap');
                  if (!popup) return;
                  document.body.appendChild(popup);
                  popup.classList.add('open');
                });
              });


              document.querySelectorAll('body').forEach(body => {
                body.addEventListener('click', function(e) {
                  if (e.target.matches('.close-popup')) {
                    const popup = e.target.closest('.var-popup-wrap');
                    if (!popup) return;
                    popup.classList.remove('open');
                    popup.remove();
                  }
                });
              });

          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
